<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-04 09:03:35
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-08-04 16:34:15
 * @Description: 当前状态
-->
<template>
  <div class="wrap">
    <!-- 状态 -->
    <h2 class="title">{{$t('route.requisitionNeedDetail')}}（{{ dataForm.status | getStatusStr(that) }}）</h2>
    <div class="status-warp">
      <!-- 状态 和描述 -->
      <div class="left">
        <div class="row">
          <span class="label">{{$t('product.requisitionNo')}}</span>
          {{ dataForm.demandCode || '-' }}
        </div>
        <div class="row">
          <span class="label">{{$t('product.status')}}</span>
          {{ dataForm.status | getStatusDes(that) }}
        </div>
        <!-- 插槽 显示按钮 在父节点调用 -->
        <slot name="btns"></slot>
      </div>
      <!-- 图标 -->
      <div class="right">
        <div class="item" v-for="i of 5" :key="i">
          <div v-if="i !== 1" class="line"></div>
          <!-- 待受理 -->
          <div
            class="circle-wrap"
            :class="{ active: [1, 2].includes(i) }"
            v-if="dataForm.status === 0"
          >
            <div class="circle">
              <template v-if="![1, 2].includes(i)">{{ i }}</template>
              <template v-else>
                <i class="el-icon-more" v-if="i === 2"></i>
                <i class="el-icon-check" v-else></i>
              </template>
            </div>
            <div>{{ i | getCircleDes0(that) }}</div>
          </div>
          <!-- 待确认 -->
          <div
            class="circle-wrap"
            :class="{ active: [1, 2, 3].includes(i) }"
            v-if="dataForm.status === 1"
          >
            <div class="circle" :class="{ operation: i === 3 }">
              <template v-if="![1, 2, 3].includes(i)">{{ i }}</template>
              <template v-else>
                <i class="el-icon-more" v-if="i === 3"></i>
                <i class="el-icon-check" v-else></i>
              </template>
            </div>
            <div>{{ i | getCircleDes1(that) }}</div>
          </div>
          <!-- 已取消 -->
          <div
            class="circle-wrap"
            :class="{ active: [1, 2, 3].includes(i) }"
            v-if="dataForm.status === 4"
          >
            <div class="circle">
              <template v-if="![1, 2, 3].includes(i)">{{ i }}</template>
              <template v-else>
                <i class="el-icon-check"></i>
              </template>
            </div>
            <div>{{ i | getCircleDes4(that) }}</div>
          </div>
          <!-- 待评价 -->
          <div
            class="circle-wrap"
            :class="{ active: [1, 2, 3, 4, 5].includes(i) }"
            v-if="dataForm.status === 5"
          >
            <div class="circle" :class="{ operation: i === 5 }">
              <template v-if="![1, 2, 3, 4, 5].includes(i)">{{ i }}</template>
              <template v-else>
                <i class="el-icon-more" v-if="i === 5"></i>
                <i class="el-icon-check" v-else></i>
              </template>
            </div>
            <div>{{ i | getCircleDes5(that) }}</div>
          </div>
          <!-- 已评价 -->
          <div
            class="circle-wrap"
            :class="{ active: [1, 2, 3, 4, 5].includes(i) }"
            v-if="dataForm.status === 6"
          >
            <div class="circle">
              <template v-if="![1, 2, 3, 4, 5].includes(i)">{{ i }}</template>
              <template v-else>
                <i class="el-icon-check"></i>
              </template>
            </div>
            <div>{{ i | getCircleDes6(that) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataForm: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  filters: {
    // 获取状态描述
    getStatusStr (status, that) {
      let str = '-'
      switch (status) {
        case 0:
          str = that.$t('applystatus.waiting')
          break
        case 1:
          str = that.$t('applystatus.confirm')
          break
        case 4:
          str = that.$t('applystatus.cancel')
          break
        case 5:
          str = that.$t('applystatus.complete')
          break
        case 6:
          str = that.$t('applystatus.evaluate')
          break
        default:
          break
      }
      return str
    },
    // 获取状态详细描述
    getStatusDes (status, that) {
      let str = '-'
      switch (status) {
        case 0:
          str = that.$t('applystatus.statusDes1')
          break
        case 1:
          str = that.$t('applystatus.statusDes2')
          break
        case 4:
          str = that.$t('applystatus.statusDes3')
          break
        case 5:
          str = that.$t('applystatus.statusDes4')
          break
        case 6:
          str = that.$t('applystatus.statusDes5')
          break
        default:
          break
      }
      return str
    },
    // 根据状态显示不同的描述
    getCircleDes0 (i, that) {
      let str = '-'
      switch (i) {
        case 1:
          str = that.$t('applystatus.submitted')
          break
        case 2:
          str = that.$t('applystatus.waiting')
          break
        case 3:
          str = that.$t('applystatus.confirm')
          break
        case 4:
          str = that.$t('applystatus.beComplete')
          break
        case 5:
          str = that.$t('applystatus.beEvaluate')
          break
        default:
          break
      }
      return str
    },
    getCircleDes1 (i, that) {
      let str = '-'
      switch (i) {
        case 1:
          str = that.$t('applystatus.submitted')
          break
        case 2:
          str = that.$t('applystatus.processed')
          break
        case 3:
          str = that.$t('applystatus.confirm')
          break
        case 4:
          str = that.$t('applystatus.beComplete')
          break
        case 5:
          str = that.$t('applystatus.beEvaluate')
          break
        default:
          break
      }
      return str
    },
    getCircleDes4 (i, that) {
      let str = '-'
      switch (i) {
        case 1:
          str = that.$t('applystatus.submitted')
          break
        case 2:
          str = that.$t('applystatus.processed')
          break
        case 3:
          str = that.$t('applystatus.cancel')
          break
        case 4:
          str = that.$t('applystatus.beComplete')
          break
        case 5:
          str = that.$t('applystatus.beEvaluate')
          break
        default:
          break
      }
      return str
    },
    getCircleDes5 (i, that) {
      let str = '-'
      switch (i) {
        case 1:
          str = that.$t('applystatus.submitted')
          break
        case 2:
          str = that.$t('applystatus.processed')
          break
        case 3:
          str = that.$t('applystatus.confirmed')
          break
        case 4:
          str = that.$t('applystatus.complete')
          break
        case 5:
          str = that.$t('applystatus.beEvaluate')
          break
        default:
          break
      }
      return str
    },
    getCircleDes6 (i, that) {
      let str = '-'
      switch (i) {
        case 1:
          str = that.$t('applystatus.submitted')
          break
        case 2:
          str = that.$t('applystatus.processed')
          break
        case 3:
          str = that.$t('applystatus.confirmed')
          break
        case 4:
          str = that.$t('applystatus.complete')
          break
        case 5:
          str = that.$t('applystatus.evaluate')
          break
        default:
          break
      }
      return str
    }
  },
  data () {
    return {
      that: this,
      status: {
        1: {
          label: this.$t('applystatus.submitted')
        },
        2: {
          label: this.$t('applystatus.waiting')
        },
        3: {
          label: this.$t('applystatus.confirm')
        },
        4: {
          label: this.$t('applystatus.beComplete')
        },
        5: {
          label: this.$t('applystatus.beEvaluate')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  background: #fff;
  padding: 20px;
  .title {
    margin: 0 0 20px 0;
    font-size: 20px;
    color: #262626;
  }
}

.row {
  display: flex;
  align-items: center;

  .label {
    width: 140px;
    padding: 0 12px 0 0;
    color: #606266;
    font-size: 14px;
    line-height: 40px;
    text-align: right;

    &::after {
      content: '：';
    }
  }
}

.status-warp {
  display: flex;
  >div{
    flex: 1;
  }

  .right {
    display: flex;
    flex: 1;
    padding-left: 93px;

    .item {
      display: flex;

      .circle-wrap {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 0 10px;
        color: #cacaca;
        text-align: center;
        &.active {
          color: #23c259;
        }

        div:last-child {
          word-break: keep-all;
        }
      }

      .circle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 35px;
        height: 35px;
        margin-bottom: 5px;
        font-size: 16px;
        border: 2px solid currentColor;
        border-radius: 50%;
        &.operation {
          background: #23c259;
          color: #fff;
        }
      }

      .line {
        display: inline-block;
        width: 20px;
        height: 2px;
        background: #cacaca;
        content: '';
        margin-top: 17.5px;
      }
    }
  }
}
</style>
